"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
var EssentialTipsTabs_1 = require("../../../../constants/EssentialTipsTabs");
var classnames_1 = __importDefault(require("classnames"));
var Tabs = react_1.memo(function (_a) {
    var match = _a.match;
    var t = react_i18next_1.useTranslation('common').t;
    var history = react_router_dom_1.useHistory();
    var pathname = react_router_dom_1.useLocation().pathname;
    var _b = react_1.useState(EssentialTipsTabs_1.EssentialTipsTabs[0].name), activeStep = _b[0], setActiveStep = _b[1];
    react_1.useEffect(function () {
        setActiveStep(pathname.split('/')[3]);
    }, [pathname]);
    var handleOpenCurrentStep = function (step) {
        history.push(match.url + "/" + step);
    };
    return (react_1.default.createElement("div", { className: "ui four item menu" }, EssentialTipsTabs_1.EssentialTipsTabs.map(function (tab) { return (react_1.default.createElement("a", { key: tab.id, className: classnames_1.default('item', {
            active: activeStep === tab.name,
        }), onClick: function () { return handleOpenCurrentStep(tab.name); } },
        tab.icon,
        react_1.default.createElement("span", null, t(tab.translationText)))); })));
});
exports.default = Tabs;
